module.exports = __webpack_public_path__ + "static/media/hwaitChecked.04fa06d4.svg";